import { render, staticRenderFns } from "./xx_regist_succ.vue?vue&type=template&id=751e0374&scoped=true&"
import script from "./xx_regist_succ.vue?vue&type=script&lang=js&"
export * from "./xx_regist_succ.vue?vue&type=script&lang=js&"
import style0 from "./xx_regist_succ.vue?vue&type=style&index=0&id=751e0374&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751e0374",
  null
  
)

export default component.exports